import * as React from 'react';
import { ukCountry } from '../../core/constants';
import { country } from '../../config.local';
import FooterLink from './FooterLink';

const ReleaseNotesLink = () => {
	const getUrl = () => {
		if (country === ukCountry) return 'https://vetting.com/en-gb/release-notes';
		return 'https://vetting.com/en-au/release-notes';
	};
	return <FooterLink text="Release Notes" href={getUrl()} />;
};

export default ReleaseNotesLink;
